<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>
        交付作業
      </h1>
    </div>
    <div class="info_wrap col">
      <!-- 報廢編號，申請人員，申請日期 -->
      <div class="fixed_info">
        <div>
          <p>
            報廢編號 : {{ details.ScrapId }}
          </p>
        </div>
        <div>
          <p>
            申請人員 : {{ details.ApplicantNickName }}
          </p>
        </div>
        <div>
          <p>
            申請日期 : {{ details.ApplicationDate }}
          </p>
        </div>
      </div>
      <div class="content">
        <!-- 資產編號 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              資產編號：
            </div>
            <input ref="inputElement" type="text" class="form-control readonly_box" readonly v-model="details.AssetsId">
          </div>
        </div>
        <!-- 物品名稱 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              物品名稱：
            </div>
            <input ref="inputElement" type="text" class="form-control readonly_box" readonly
              v-model="details.AssetName">
          </div>
        </div>
        <!-- 報廢方式 -->
        <div v-show="Assets.Type === '耗材'" class="col-12">
          <div class="input-group mb-3">
            <div class="input-group-prepend">報廢方式：</div>
            <div class="check_section d-flex">
              <template v-for="(item, index) in Scrap_TypeArray" :key="item">
                <div class="form-check d-flex align-items-center">
                  <input type="radio" :id="'no' + index" name="radio" :value="item" v-model="details.ConsumableScrap"
                    :disabled="details.ConsumableScrap !== item" />
                  <label :for="'no' + index">{{ item }}</label>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- scrap_hint -->
        <div v-show="Assets.Type === '耗材'" class="col-12">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
            </div>
            <span v-if="details.ConsumableScrap == '歸還報廢'" class="scrap_hint">對已出庫耗材進行報廢處理</span>
            <span v-else-if="details.ConsumableScrap == '庫內報廢'" class="scrap_hint">對庫內耗材進行報廢處理(有庫存上限)</span>
          </div>
        </div>
        <!-- 報廢數量 -->
        <div v-show="Assets.Type === '耗材'" class="col-12">
          <div class="input-group  mb-3">
            <div class="input-group-prepend">報廢數量：</div>
            <div class="num_wrap d-flex ">
              <div class="number-input-box">
                <input class="input-number readonly_box" type="number" readonly v-model="details.ConsumableNum" />
                <span class="scrap_quantity">{{ Assets.Unit }}</span>
                <!-- <span class="scrap_quantity_storage">（總庫存量 {{ Assets.Max }}）</span> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 報廢原因 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">
              報廢原因：
            </div>
            <textarea style="height: 200px;" class="form-control readonly_box" v-model="details.Reason"
              readonly></textarea>
          </div>
        </div>
        <!-- 已上傳檔案 -->
        <div class="col selected_file">
          <div class="input-group mt-3">
            <div class="input-group-prepend">已上傳檔案：</div>
            <div class="d-flex  flex-column selected_file_wrap">
              <div v-for="(file, index) in details.existFile" :key="index" class="file_upload_wrap">
                <p class='file_name'>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file, file_index)" data-bs-toggle="modal"
                    data-bs-target="#viewFile_modal">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='confirm_section'>
        <h2>
          交付簽章
        </h2>
        <div class='final'>
          <!-- 交付日期 -->
          <div class="fixed_info">
            <div>
              <p>交付日期 : {{ utilsStore.today }}</p>
            </div>
          </div>
          <div class="row auth g-0">
            <!-- 交付人員 -->
            <div class="col-xl-6 col-lg-6 col-md-6 col-12 input-container">
              <div class="input-group">
                <div class="input-group-prepend"><span class='red_star'>*</span>交付人員：</div>
                <div class="input-with-icon">
                  <select class="form-select" v-model="Form.DeliveryOperator">
                    <option value="">--請選擇--</option>
                    <option v-for="option in DropdownArray.Custodian" :key="option.Value" :value="option.Value">{{ option.Text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 送修人員 -->
            <div class="col-xl-6 col-lg-6 col-md-6 col-12 input-container">
              <div class="input-group">
                <div class="input-group-prepend">報廢人員：</div>
                <div class="input-with-icon">
                  <input type="text" class="form-control readonly_box" readonly :value="utilsStore.user.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col button_wrap">
        <button class="back_btn" @click="goBack">回上一頁</button>
        <button class="send_btn" @click="submit" :disabled="!Form.DeliveryOperator" :class="{ send_btn_disabled: !Form.DeliveryOperator }">送出</button>
      </div>
    </div>
  </div>
  <view_modal />
</template>

<script setup>
import {
  ref,
  reactive,
  onMounted
} from 'vue';
import view_modal from "@/components/view_modal.vue"
import Navbar from '@/components/Navbar.vue';
import router from '@/router';
import { goBack, canEnterPage } from '@/assets/js/common_fn.js'
import axios from '@/axios/tokenInterceptor';
import {
  useRoute
} from 'vue-router';
import {
  Scrap_Deliver_Status
} from '@/assets/js/enter_status';
import {
  getAssets
} from '@/assets/js/common_api';
import {
  Scrap_TypeArray
} from '@/assets/js/dropdown';
import { useAPIStore, useUtilsStore } from '@/store';
const route = useRoute();
const ScrapId = route.query.search_id;
const utilsStore = useUtilsStore();
const apiStore = useAPIStore();
const details = ref({});
const DropdownArray = reactive({
  Custodian: []
})
const Form = reactive({
  DeliveryOperator: '',
})
const Assets = reactive({
  Name: '',
  Type: '',
  Status: '',
  Unit: '',
  Max: 1,
});
onMounted(async () => {
  await getDetails();
  DropdownArray.Custodian = await apiStore.getUserNickName('', true);
});
async function getDetails() {
  axios.get(`/GetDBdata/GetScrapInfo?s_id=${ScrapId}`)
    .then((response) => {
      const data = response.data
      if (data.state === 'success') {
        canEnterPage(data.resultList.Status, Scrap_Deliver_Status)
        details.value = data.resultList;
        Form.DeliveryOperator = details.value.Applicant;
        // 為了耗材顯示
        getAssets(details.value.AssetsId)
          .then((data) => {
            Assets.Type = data.AssetType;
            Assets.Unit = data.Unit;
            Assets.Max = data.Number;
          })
          .catch((error) => {
            console.error(error);
          })
      } else {
        alert(data.messages)
      }
    })
    .catch((error) => {
      console.error(error);
    })
}

async function submit() {
  if (!utilsStore.checkRequired(Form, ['DeliveryOperator'],)) return
  const requestData = {
    ScrapId: ScrapId,
    DeliveryOperator: Form.DeliveryOperator,
  }
  axios.post('/ScrapMng/Delivery', requestData)
    .then((response) => {
      const data = response.data
      if (data.state === 'success') {
        alert('傳送報廢交付表單成功\n單號為:' + data.resultList.S_ID);
        router.push({
          name: 'Scrap_Datagrid'
        });
      } else {
        alert(data.messages);
      }
    })
    .catch((error) => {
      console.error(error);
    })
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.readonly_box {
  @include readonly_box;
}

.input-number {
  @include count_btn;
}

span {
  @include red_star
}

.scrap_quantity,
.scrap_quantity_storage {
  font-size: 20px;
  color: white;
  font-weight: 700;
  margin-left: 10px;
}

.scrap_hint {
  font-weight: 700;
  color: #00438B;
  font-size: 18px;
}

.check_section {
  gap: 10px;

  .form-check {
    gap: 5px;
    padding: 0;
    margin: 0;

    input {
      width: 15px;
      padding: 0;
      height: 15px;
      border-radius: 50%;
    }

    label {
      color: white;
      font-size: 20px;
      font-weight: 600;
    }
  }
}

.modal {
  .modal-body {
    padding: 20px;

  }

  .modal-content {
    margin: auto;
  }

  .modal-header {
    h5 {
      font-weight: 700;
    }

    background: #528091;
    color: white;
    display: flex;
    justify-content: center;
  }
}

.file_wrap {
  display: flex;
  flex-direction: column;

  .choose_btn {
    margin-bottom: 10px;
    @include choose_file_btn;

    &:hover {
      background: #3f608f;
    }
  }
}

.file_name::before {
  margin-right: 5px;
  content: '·';
  font-weight: 700;
  color: white;
}

.selected_file {
  display: flex;
  align-items: center;

  .selected_file_wrap {
    flex-direction: column;

    .file_upload_wrap {
      margin-bottom: 0;
      display: flex;

      img {
        width: 25px;
        height: 25px;
      }

      p {
        font-weight: 700;
        margin-bottom: 5px;
        color: white;
        word-break: break-word;

        &::before {
          margin-right: 10px;
          content: '·';
          font-weight: 700;
          color: white;
        }
      }
    }
  }
}

.button_wrap {
  display: flex;
  justify-content: space-between;
  margin: 30px auto 5%;

  button {
    &:nth-child(1) {
      @include back_to_previous_btn;

      &:hover {
        background-color: #5d85bb;
      }
    }
  }

  .send_btn {
    @include search_and_send_btn;

    &:hover {
      background-color: #5e7aa2;
    }
  }

  .send_btn_disabled {
    background: #878787;

    &:hover {
      background: #878787;
    }
  }
}

.main_section {
  h2 {
    margin-top: 50px;
    text-align: center;
    font-size: 35px;
    font-weight: 600;
    @include title_color;
  }

  .info_wrap {
    .fixed_info {
      @include fixed_info;

      p {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    .content {
      @include content_bg;

      .input-group {
        flex-wrap: nowrap;

        .input-group-prepend {
          white-space: nowrap;
          color: white;
          font-weight: 700;
          font-size: 20px;
        }
      }

    }

    .confirm_section {
      .auth {
        border-radius: 0 0 10px 10px;
        background: white;

        .input-group {
          display: flex;
          white-space: nowrap;
          flex-wrap: nowrap;
          justify-content: center;
        }

        button {
          @include auth_btn;

          &:hover {
            background: #5a6d87;
          }
        }

        .form-control {
          height: 35px;
          margin-right: 5px;
        }

        .input-group-prepend {
          font-weight: 700;
          font-size: 20px;
          text-align: end;
          position: relative;

        }

        .input-container {
          position: relative;
          align-self: center;
        }

        .input-with-icon {
          width: 180px;
        }

        .checkmark-icon {
          position: absolute;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
        }
      }

      .modal {
        .modal-body {
          padding: 16px 16px 0;
        }

        .modal-content {
          width: 400px;
          margin: auto;
        }

        .input-group-prepend {
          width: auto;
        }

        .modal-footer {
          padding: 0 12px 12px;
          border: none;
        }

        .modal-header {
          h5 {
            font-weight: 700;
          }

          background: #3D4E61;
          color: white;

          .close_icon {
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 1200px) {
  .main_section {


    .info_wrap {
      margin: 8px auto 5%;
      width: 750px;

      .content {
        .input-group {

          .readonly_box {
            height: 37px;
          }

          .form-control {
            height: 37px;
            border-radius: 0;
          }

          .input-group-prepend {
            text-align: end;
            width: 120px;

          }

        }
      }

      .button_wrap {
        width: 220px;

      }

      .confirm_section {
        .auth {
          height: 80px;
          padding: 20px;


          .form-control,
          .form-select {
            width: 180px;
          }

          .checkmark-icon {
            top: 10%;
            left: 89%;
          }
        }

      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {


    .info_wrap {
      margin: 8px auto 5%;
      padding: 0 5%;

      .content {
        .input-group {
          width: 100%;

          .num_wrap {
            .input-number {
              width: 50%;
            }
          }

          .readonly_box {
            height: 37px;
            width: 100%;
          }

          .form-control {
            height: 37px;
            width: 55%;
          }

          .input-group-prepend {
            text-align: end;
            width: 140px;

          }
        }

      }

      .button_wrap {
        width: 220px;

      }

      .confirm_section {
        .auth {
          height: 80px;
          padding: 20px;

          .checkmark-icon {
            top: 10%;
            left: 93%;
          }
        }

      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .main_section {

    .readonly_box,
    .input-group .num_wrap,
    .form-control {
      margin-left: unset !important;
    }

    .form-control,
    .input-number,
    .num_wrap .number-input-box {
      width: 100%;
    }

    .info_wrap {
      padding: 0 5%;

      .fixed_info {
        height: unset;
        flex-direction: column;
        padding: 10px;

      }

      .content {
        .input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
          margin-left: unset;
          border-radius: 5px;
          margin-top: 5px;
        }

        .input-group {
          flex-direction: column;

          .num_wrap {
            .number-input-box {
              width: 100%;

              .input-number {
                width: 20%;
              }
            }
          }



        }
      }

      .button_wrap {
        width: 200px;

      }

      .confirm_section {
        .auth {
          padding: 10px;

          .input-group {
            margin: 5px 0;
          }



          .checkmark-icon {
            top: 10%;
            left: 94%;
          }
        }

      }
    }
  }
}
</style>